import React from 'react';
import { useAuth } from '../../context/AuthContext';
import { FiUser, FiMail, FiSettings, FiBriefcase } from 'react-icons/fi';

const MyProfile: React.FC = () => {
    const { user } = useAuth();

    return (
        <div className="max-w-5xl mx-auto py-12 px-4 sm:px-6 lg:px-8 animate-fade-in-up">
            <div className="relative">
                {/* Background Banner */}
                <div className="h-48 w-full rounded-3xl bg-gradient-to-r from-blue-600 to-indigo-600 shadow-xl overflow-hidden relative">
                    <div className="absolute inset-0 bg-black/10"></div>
                    <div className="absolute -bottom-24 -left-24 w-64 h-64 bg-white/10 rounded-full blur-3xl"></div>
                    <div className="absolute -top-24 -right-24 w-64 h-64 bg-white/10 rounded-full blur-3xl"></div>
                </div>

                {/* Profile Card */}
                <div className="glass relative -mt-20 mx-8 rounded-3xl p-8 flex flex-col md:flex-row items-center md:items-end space-y-6 md:space-y-0 md:space-x-8">
                    <div className="relative group">
                        <img 
                            src={user?.photoURL || 'https://via.placeholder.com/150'} 
                            alt="Profile" 
                            className="w-32 h-32 rounded-full object-cover border-4 border-white shadow-2xl group-hover:scale-105 transition-transform duration-300"
                        />
                        <div className="absolute inset-0 rounded-full ring-4 ring-indigo-500/30"></div>
                    </div>
                    
                    <div className="flex-1 text-center md:text-left mb-2">
                        <h1 className="text-3xl font-bold text-slate-900 mb-1">{user?.displayName || 'Traveler'}</h1>
                        <p className="text-slate-500 font-medium flex items-center justify-center md:justify-start">
                            <FiMail className="mr-2" /> {user?.email}
                        </p>
                    </div>

                    <div className="mb-2">
                        <button className="bg-indigo-50 hover:bg-indigo-100 text-indigo-600 px-6 py-2.5 rounded-full font-semibold shadow-sm border border-indigo-200 transition-all flex items-center">
                            <FiSettings className="mr-2" /> Edit Profile
                        </button>
                    </div>
                </div>
            </div>

            {/* Content Grid */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-12">
                <div className="glass rounded-3xl p-8 md:col-span-1">
                    <h2 className="text-xl font-bold text-slate-900 mb-6 flex items-center">
                        <FiUser className="mr-2 text-indigo-600" /> Account Details
                    </h2>
                    <div className="space-y-4">
                        <div>
                            <label className="text-sm font-medium text-slate-400">Full Name</label>
                            <p className="text-slate-900 font-medium">{user?.displayName}</p>
                        </div>
                        <div>
                            <label className="text-sm font-medium text-slate-400">Email Address</label>
                            <p className="text-slate-900 font-medium">{user?.email}</p>
                        </div>
                        <div>
                            <label className="text-sm font-medium text-slate-400">Account Status</label>
                            <p className="text-emerald-600 font-semibold bg-emerald-50 inline-block px-3 py-1 rounded-full text-xs mt-1">Active</p>
                        </div>
                    </div>
                </div>

                <div className="glass rounded-3xl p-8 md:col-span-2">
                    <h2 className="text-xl font-bold text-slate-900 mb-6 flex items-center">
                        <FiBriefcase className="mr-2 text-indigo-600" /> Recent Activity
                    </h2>
                    
                    <div className="bg-slate-50 rounded-2xl p-8 border border-slate-100 text-center flex flex-col items-center justify-center h-48">
                        <div className="text-slate-300 mb-3"><FiBriefcase size={40} /></div>
                        <p className="text-slate-500 font-medium">No recent bookings found.</p>
                        <button className="mt-4 text-indigo-600 font-semibold hover:text-indigo-700">Explore Destinations</button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MyProfile;
